import { TypePolicy } from '@apollo/client';

const StandingOrder: TypePolicy = {
  keyFields: ['standingOrderId'],
};

export default StandingOrder;
